module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('p', {
    staticClass: "ct",
    attrs: {
      "id": "toc_marker-6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/High_Stakes2#Contents-A"
    }
  }, [_vm._v("Epigraph")])]), _vm._v(" "), _c('p', {
    staticClass: "fp para-style-override-3"
  }, [_vm._v("“I have an agreement with Father Time. "), _c('br'), _vm._v("I don’t mess with him, and he don’t mess with me.”")]), _vm._v(" "), _c('p', {
    staticClass: "fp para-style-override-4"
  }, [_vm._v("—Bernard Hopkins, age 49, "), _c('br'), _vm._v("world light-heavyweight boxing champion")]), _vm._v(" "), _c('p', {
    staticClass: "fp para-style-override-3"
  }, [_vm._v("“Life’s not the breaths you take but the moments "), _c('br'), _vm._v("that take your breath away.”")]), _vm._v(" "), _c('p', {
    staticClass: "fp para-style-override-4"
  }, [_vm._v("—George Strait")]), _vm._v(" "), _c('p', {
    staticClass: "fp para-style-override-5"
  }, [_vm._v("“Something, like nothing, happens anywhere.”")]), _vm._v(" "), _c('p', {
    staticClass: "fp para-style-override-6"
  }, [_vm._v("—Phillip Larkin")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f92f3f0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/High_Stakes-5.vue
// module id = 75
// module chunks = 0